import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import { useQuery } from '@tanstack/react-query';

import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

import { getAllDevices } from 'api/bks';

import 'mapbox-gl/dist/mapbox-gl.css';

// props-types is a library for typechecking of props
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Box from '@mui/material/Box';

import { center, bbox, bboxPolygon } from "@turf/turf";
import geoViewport from "@mapbox/geo-viewport";
import { useNavigate } from 'react-router-dom';
import { group_outliners } from 'helper/group_outliners';
import { getUserAccessLevel } from 'helper/user';

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function setFeatures(group) {
    var features = group.geojson;
    // console.log(group);

    features.forEach(function (feature) {
        feature.properties = {
            group_id: group.group_id,
            name: group.name,
            parent_id: group.parent_id
            // uuids: group.uuids
        };
    });

    return features;
}


function ExploringMapSubgroups({ map, mapPadding, extraPadding, user_role = "viewer", group, sidebarOpen, menuToggled, setMenuToggled, deviceStyle = 'desktop' }) {

    const navigate = useNavigate();
    const set_padding = 100;

    const handleGroupClick = (e) => {
        e.preventDefault();
    }

    const handleSubgroupClick = (e) => {
        e.preventDefault();
        navigate("/explore/groups/" + e.features[0].properties.parent_id + "/" + e.features[0].properties.group_id);
    }

    const handleMapClick = (e) => {
        if (!e.defaultPrevented) {
            navigate("/explore/groups");
        }
    }

    const handleMouseEnter = (e) => {
        map.current.getCanvas().style.cursor = 'pointer';
    }

    const handleMouseLeave = (e) => {
        map.current.getCanvas().style.cursor = '';
    }

    useEffect(() => { // initial

        var bounds = bbox({
            "type": "FeatureCollection",
            "features": setFeatures(group)
        });

        // console.log(bounds)
        var polygon = bboxPolygon(bounds);
        // console.log(polygon);

        if (!sidebarOpen) {
            if (extraPadding) {
                var map_padding = [0, 250];
            }
            else {
                var map_padding = [0, 0];
            }
        }
        else {
            if (extraPadding) {
                var map_padding = [600, 250];
            }
            else {
                var map_padding = [600, 0];
            }
        }

        if (map.current) {
            // console.log('here')
            if (menuToggled) {
                if (deviceStyle == 'mobile') {
                    var padding = {
                        top: set_padding / 2,
                        bottom: set_padding / 2,
                        right: set_padding / 2,
                        left: set_padding / 2,
                    }
                }
                else {
                    var padding = {
                        top: set_padding,
                        bottom: map_padding[1] + set_padding,
                        right: set_padding,
                        left: map_padding[0] + set_padding,
                    }
                }
                map.current.fitBounds(polygon.bbox, {
                    // linear: true,
                    padding: padding,
                    // duration: 1500
                });
                setMenuToggled(false);

            }
            else {
                // console.log('here3')
                map.current.easeTo({
                    padding: {
                        left: map_padding[0],
                        bottom: map_padding[1]
                    },
                    duration: 500
                });
            }
        }
    }, [sidebarOpen]);

    useEffect(() => { //mount
        if (map.current) {

            var existing_base_layer = map.current.getLayer('geojson-base');
            var existing_base_source = map.current.getSource('geojson-base');

            if (!existing_base_source) {
                map.current.addSource('geojson-base', {
                    type: 'geojson',
                    data: {
                        "type": "FeatureCollection",
                        "features": setFeatures(group)
                    }
                });
            }
            if (!existing_base_layer) {
                map.current.addLayer({
                    id: 'geojson-base',
                    type: 'fill',
                    source: 'geojson-base',
                    paint: {
                        "fill-opacity": 0.1,
                        "fill-color": "black"
                    }
                }).addLayer({
                    id: 'geojson-border-base',
                    type: 'line',
                    source: 'geojson-base',
                    paint: {
                        "line-color": "black",
                        "line-width": 2,
                        "line-opacity": 0.2
                    }
                });

                map.current.on('click', 'geojson-base', handleGroupClick);
            }

            if (group.subgroups.length > 0) {
                group_outliners.forEach(function (subgroup) {
                    if (typeof subgroup.parent_id != 'undefined' && group.group_id == subgroup.parent_id) {

                        var existing_group_outliner_layer = map.current.getLayer('geojson-outliner-' + subgroup.group_id);
                        var existing_group_outliner_source = map.current.getSource('geojson-outliner-' + subgroup.group_id);

                        if (!existing_group_outliner_source) {
                            map.current.addSource('geojson-outliner-' + subgroup.group_id, {
                                type: 'geojson',
                                data: {
                                    "type": "FeatureCollection",
                                    "features": setFeatures(subgroup)
                                }
                            });
                        }
                        if (!existing_group_outliner_layer) {
                            map.current.addLayer({
                                id: 'geojson-outliner-' + subgroup.group_id,
                                type: 'fill',
                                source: 'geojson-outliner-' + subgroup.group_id,
                                paint: {
                                    "fill-opacity": 0,
                                    // "fill-color": "black"
                                }
                            }).addLayer({
                                id: 'geojson-border-outliner-' + subgroup.group_id,
                                type: 'line',
                                source: 'geojson-outliner-' + subgroup.group_id,
                                paint: {
                                    // "line-color": "black",
                                    "line-opacity": 0
                                }
                            });

                            map.current.on('click', 'geojson-outliner-' + subgroup.group_id, handleSubgroupClick);
                            map.current.on('mouseenter', 'geojson-outliner-' + subgroup.group_id, handleMouseEnter);
                            map.current.on('mouseleave', 'geojson-outliner-' + subgroup.group_id, handleMouseLeave);
                        }
                    }
                });

                group.subgroups.forEach(function (subgroup) {

                    var existing_group_layer = map.current.getLayer('geojson-' + subgroup.group_id);
                    var existing_group_source = map.current.getSource('geojson-' + subgroup.group_id);

                    if (!subgroup.all_updated) {
                        var polygon_colour = "#ff667c";
                    }
                    else if (subgroup.devices_monitored > 0 && getUserAccessLevel(user_role, 'technician')) {
                        var polygon_colour = "#edaa00";
                    }
                    else {
                        var polygon_colour = "#58ba2d";
                    }

                    if (!existing_group_source) {
                        map.current.addSource('geojson-' + subgroup.group_id, {
                            type: 'geojson',
                            data: {
                                "type": "FeatureCollection",
                                "features": setFeatures(subgroup)
                            }
                        });
                    }
                    if (!existing_group_layer) {
                        map.current.addLayer({
                            id: 'geojson-' + subgroup.group_id,
                            type: 'line',
                            source: 'geojson-' + subgroup.group_id,
                            paint: {
                                "line-color": polygon_colour,
                                "line-width": 4,
                            }
                        });

                        map.current.on('click', 'geojson-' + subgroup.group_id, handleSubgroupClick);
                        // map.current.on('mouseenter', 'geojson-' + subgroup.group_id, handleMouseEnter);
                        // map.current.on('mouseleave', 'geojson-' + subgroup.group_id, handleMouseLeave);
                    }
                })
            }

            map.current.on('click', handleMapClick);
        }
    }, []);

    useEffect(() => () => { //unmount

        var existing_base_layer = map.current.getLayer('geojson-base');
        if (existing_base_layer) {
            map.current.removeLayer('geojson-base');
            map.current.removeLayer('geojson-border-base');
            map.current.removeSource('geojson-base');

            map.current.off('click', 'geojson-base', handleGroupClick);
        }

        if (group.subgroups.length > 0) {
            group_outliners.forEach(function (subgroup) {
                var existing_group_outliner_layer = map.current.getLayer('geojson-outliner-' + subgroup.group_id);
                if (existing_group_outliner_layer) {
                    map.current.removeLayer('geojson-outliner-' + subgroup.group_id);
                    map.current.removeLayer('geojson-border-outliner-' + subgroup.group_id);
                    map.current.removeSource('geojson-outliner-' + subgroup.group_id);

                    map.current.off('click', 'geojson-outliner-' + subgroup.group_id, handleSubgroupClick);
                    map.current.off('mouseenter', 'geojson-outliner-' + subgroup.group_id, handleMouseEnter);
                    map.current.off('mouseleave', 'geojson-outliner-' + subgroup.group_id, handleMouseLeave);
                }
            });

            group.subgroups.forEach(function (subgroup) {
                var existing_group_layer = map.current.getLayer('geojson-' + subgroup.group_id);
                if (existing_group_layer) {
                    map.current.removeLayer('geojson-' + subgroup.group_id);
                    map.current.removeSource('geojson-' + subgroup.group_id);

                    map.current.off('click', 'geojson-' + subgroup.group_id, handleSubgroupClick);
                    // map.current.off('mouseenter', 'geojson-' + subgroup.group_id, handleMouseEnter);
                    // map.current.off('mouseleave', 'geojson-' + subgroup.group_id, handleMouseLeave);
                }
            });
        }
        map.current.off('click', handleMapClick);

    }, []);
}

ExploringMapSubgroups.propTypes = {
    map: PropTypes.object,
    mapPadding: PropTypes.array,
    user_role: PropTypes.string,
    group: PropTypes.object,
    sidebarOpen: PropTypes.bool,
    menuToggled: PropTypes.bool,
    setMenuToggled: PropTypes.func,
    extraPadding: PropTypes.bool,
};

export default ExploringMapSubgroups;